import type { ExtendedGenerationRecord } from 'dynamo-daos';

import apiRequest from './apiRequest';

export default async function getProjectHistory(
  projectID: string,
  limit: number,
  nextToken?: string,
) {
  const { data, error } = await apiRequest<{
    generationHistory: Array<
      ExtendedGenerationRecord & {
        // These are referenced in code but not in the API response:
        renderedPngURL?: string;
        renderPrompt?: string;
      }
    >;
    nextToken: string;
  }>(
    'mogen-orchestration',
    `/v2/projects/${projectID}/history?limit=${limit}&${nextToken ? `nextToken=${nextToken}` : ''}`,
  );

  return {
    data: data,
    error,
  };
}
